import { render, staticRenderFns } from "./AngleIcon.vue?vue&type=template&id=18ce03c6"
import script from "./AngleIcon.vue?vue&type=script&lang=js"
export * from "./AngleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports